export const showAddTierModal = () => {
    return {
      type: "SHOW_ADD_TIER_MODAL",
    };
  };
  
  export const hideAddTierModal = () => {
    return {
      type: "HIDE_ADD_TIER_MODAL",
    };
  };
  